const languageList = [
    { name: '简体中文', enName: 'Simplified Chinese', code: 'zh-CHS' },
    { name: '繁体中文', enName: 'Traditional Chinese', code: 'zh-CHT' },
    { name: '英语', enName: 'English', code: 'en' },
    { name: '法语', enName: 'French', code: 'fr' },
    { name: '日语', enName: 'Japanese', code: 'ja' },
    { name: '德语', enName: 'German', code: 'de' },
    { name: '韩语', enName: 'Korean', code: 'ko' },
    { name: '俄语', enName: 'Russian', code: 'ru' },
    { name: '泰语', enName: 'Thai', code: 'th' },
    { name: '老挝语', enName: 'Lao', code: 'lo' },
    { name: '阿拉伯语', enName: 'Arabic', code: 'ar' },
    { name: '西班牙语', enName: 'Spanish', code: 'es' },
    { name: '印地语', enName: 'Hindi', code: 'hi' },
    { name: '印度尼西亚语', enName: 'Indonesian', code: 'id' },
    { name: '意大利语', enName: 'Italian', code: 'it' },
    { name: '荷兰语', enName: 'Dutch', code: 'nl' },
    { name: '葡萄牙语', enName: 'Portuguese', code: 'pt' },
    { name: '越南语', enName: 'Vietnamese', code: 'vi' },
    { name: '南非荷兰语', enName: 'Afrikaans', code: 'af' },
    { name: '阿姆哈拉语', enName: 'Amharic', code: 'am' },
    { name: '阿塞拜疆语', enName: 'Azerbaijani', code: 'az' },
    { name: '白俄罗斯语', enName: 'Belarusian', code: 'be' },
    { name: '保加利亚语', enName: 'Bulgarian', code: 'bg' },
    { name: '孟加拉语', enName: 'Bengali', code: 'bn' },
    { name: '波斯尼亚语', enName: 'Bosnian', code: 'bs' },
    { name: '加泰隆语', enName: 'Catalan', code: 'ca' },
    { name: '宿务语', enName: 'Cebuano', code: 'ceb' },
    { name: '科西嘉语', enName: 'Corsican', code: 'co' },
    { name: '捷克语', enName: 'Czech', code: 'cs' },
    { name: '威尔士语', enName: 'Welsh', code: 'cy' },
    { name: '丹麦语', enName: 'Danish', code: 'da' },
    { name: '希腊语', enName: 'Greek', code: 'el' },
    { name: '世界语', enName: 'Esperanto', code: 'eo' },
    { name: '爱沙尼亚语', enName: 'Estonian', code: 'et' },
    { name: '巴斯克语', enName: 'Basque', code: 'eu' },
    { name: '波斯语', enName: 'Persian', code: 'fa' },
    { name: '芬兰语', enName: 'Finnish', code: 'fi' },
    { name: '斐济语', enName: 'Fijian', code: 'fj' },
    { name: '弗里西语', enName: 'Frisian', code: 'fy' },
    { name: '爱尔兰语', enName: 'Irish', code: 'ga' },
    { name: '苏格兰盖尔语', enName: 'Scottish Gaelic', code: 'gd' },
    { name: '加利西亚语', enName: 'Galician', code: 'gl' },
    { name: '古吉拉特语', enName: 'Gujarati', code: 'gu' },
    { name: '豪萨语', enName: 'Hausa', code: 'ha' },
    { name: '夏威夷语', enName: 'Hawaiian', code: 'haw' },
    { name: '希伯来语', enName: 'Hebrew', code: 'he' },
    { name: '克罗地亚语', enName: 'Croatian', code: 'hr' },
    { name: '海地克里奥尔语', enName: 'Haitian Creole', code: 'ht' },
    { name: '匈牙利语', enName: 'Hungarian', code: 'hu' },
    { name: '亚美尼亚语', enName: 'Armenian', code: 'hy' },
    { name: '伊博语', enName: 'Igbo', code: 'ig' },
    { name: '冰岛语', enName: 'Icelandic', code: 'is' },
    { name: '爪哇语', enName: 'Javanese', code: 'jw' },
    { name: '格鲁吉亚语', enName: 'Georgian', code: 'ka' },
    { name: '哈萨克语', enName: 'Kazakh', code: 'kk' },
    { name: '高棉语', enName: 'Khmer', code: 'km' },
    { name: '卡纳达语', enName: 'Kannada', code: 'kn' },
    { name: '库尔德语', enName: 'Kurdish', code: 'ku' },
    { name: '柯尔克孜语', enName: 'Kyrgyz', code: 'ky' },
    { name: '拉丁语', enName: 'Latin', code: 'la' },
    { name: '卢森堡语', enName: 'Luxembourgish', code: 'lb' },
    { name: '立陶宛语', enName: 'Lithuanian', code: 'lt' },
    { name: '拉脱维亚语', enName: 'Latvian', code: 'lv' },
    { name: '马尔加什语', enName: 'Malagasy', code: 'mg' },
    { name: '毛利语', enName: 'Maori', code: 'mi' },
    { name: '马其顿语', enName: 'Macedonian', code: 'mk' },
    { name: '马拉雅拉姆语', enName: 'Malayalam', code: 'ml' },
    { name: '蒙古语', enName: 'Mongolian', code: 'mn' },
    { name: '马拉地语', enName: 'Marathi', code: 'mr' },
    { name: '马来语', enName: 'Malay', code: 'ms' },
    { name: '马耳他语', enName: 'Maltese', code: 'mt' },
    { name: '白苗语', enName: 'Hmong Daw', code: 'mww' },
    { name: '缅甸语', enName: 'Burmese', code: 'my' },
    { name: '尼泊尔语', enName: 'Nepali', code: 'ne' },
    { name: '挪威语', enName: 'Norwegian', code: 'no' },
    { name: '齐切瓦语', enName: 'Chichewa', code: 'ny' },
    { name: '克雷塔罗奥托米语', enName: 'Queretaro Otomi', code: 'otq' },
    { name: '旁遮普语', enName: 'Punjabi', code: 'pa' },
    { name: '波兰语', enName: 'Polish', code: 'pl' },
    { name: '普什图语', enName: 'Pashto', code: 'ps' },
    { name: '罗马尼亚语', enName: 'Romanian', code: 'ro' },
    { name: '信德语', enName: 'Sindhi', code: 'sd' },
    { name: '僧伽罗语', enName: 'Sinhala', code: 'si' },
    { name: '斯洛伐克语', enName: 'Slovak', code: 'sk' },
    { name: '斯洛文尼亚语', enName: 'Slovenian', code: 'sl' },
    { name: '萨摩亚语', enName: 'Samoan', code: 'sm' },
    { name: '修纳语', enName: 'Shona', code: 'sn' },
    { name: '索马里语', enName: 'Somali', code: 'so' },
    { name: '阿尔巴尼亚语', enName: 'Albanian', code: 'sq' },
    { name: '塞尔维亚语(西里尔文)', enName: 'Serbian (Cyrillic)', code: 'sr-Cyrl' },
    { name: '塞尔维亚语(拉丁文)', enName: 'Serbian (Latin)', code: 'sr-Latn' },
    { name: '塞索托语', enName: 'Sesotho', code: 'st' },
    { name: '巽他语', enName: 'Sundanese', code: 'su' },
    { name: '瑞典语', enName: 'Swedish', code: 'sv' },
    { name: '斯瓦希里语', enName: 'Swahili', code: 'sw' },
    { name: '泰米尔语', enName: 'Tamil', code: 'ta' },
    { name: '泰卢固语', enName: 'Telugu', code: 'te' },
    { name: '塔吉克语', enName: 'Tajik', code: 'tg' },
    { name: '菲律宾语', enName: 'Filipino', code: 'tl' },
    { name: '克林贡语', enName: 'Klingon', code: 'tlh' },
    { name: '汤加语', enName: 'Tongan', code: 'to' },
    { name: '土耳其语', enName: 'Turkish', code: 'tr' },
    { name: '塔希提语', enName: 'Tahitian', code: 'ty' },
    { name: '乌克兰语', enName: 'Ukrainian', code: 'uk' },
    { name: '乌尔都语', enName: 'Urdu', code: 'ur' },
    { name: '乌兹别克语', enName: 'Uzbek', code: 'uz' },
    { name: '南非科萨语', enName: 'Xhosa', code: 'xh' },
    { name: '意第绪语', enName: 'Yiddish', code: 'yi' },
    { name: '约鲁巴语', enName: 'Yoruba', code: 'yo' },
    { name: '尤卡坦玛雅语', enName: 'Yucatec Maya', code: 'yua' },
    { name: '粤语', enName: 'Cantonese', code: 'yue' },
    { name: '南非祖鲁语', enName: 'Zulu', code: 'zu' },
];

function buildLangMap(getField) {
  return languageList.reduce((map, item) => {
    if (!map.has(item.code)) {
      map.set(item.code, item[getField]);
    }
    return map;
  }, new Map());
}

const langNameByCode = buildLangMap('name');
const langEnglishNameByCode = buildLangMap('enName');

function resolveLangItem(code) {
  if (!code || code === 'auto') return null;
  if (langNameByCode.has(code)) {
    return languageList.find((item) => item.code === code);
  }

  const normalized = code.split('-')[0];
  if (langNameByCode.has(normalized)) {
    return languageList.find((item) => item.code === normalized);
  }

  return languageList.find((item) => item.code.split('-')[0] === normalized) || null;
}

function getLangNameByCode(code) {
  const item = resolveLangItem(code);
  return item?.name || (code && code !== 'auto' ? code.split('-')[0] : '') || '目标语言';
}

function getLangEnglishNameByCode(code) {
  const item = resolveLangItem(code);
  return item?.enName || (code && code !== 'auto' ? code.split('-')[0] : '') || 'target language';
}

function getAllLangLabels() {
  const labels = new Set([
    'Chinese',
    '原文',
    '译文',
    '翻译',
    'Original',
    'Translation',
    'Source',
    'Target',
  ]);
  for (const item of languageList) {
    labels.add(item.enName);
    labels.add(item.name);
  }
  return [...labels];
}

export default {
  languageList,
  getLangNameByCode,
  getLangEnglishNameByCode,
  getAllLangLabels,
};
